import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import Banner from './HomeComponents/Banner'
import ExploreCategory from './HomeComponents/ExploreCategory'
import HomeAbout from './HomeComponents/HomeAbout'
import PlatForms from './HomeComponents/PlatForms'
import FeaturedCourses from './HomeComponents/FeaturedCourses'
import ContactUs from './HomeComponents/ContactUs'
import Footer from './HomeComponents/Footer'

const Home = () => {
     const configData = useSelector(state => state.configSlice);
     const { visibleSections=null, banner=null, features=null, featuredCourses=null, aboutUs=null } = configData.home;

     useEffect(() => {
        const body = document.body;
        body.classList.remove("filter-active");
      }, []);

    return (
        <>
            <div className="homepage">
                {visibleSections && visibleSections.includes('banner') && < Banner banner={banner} />}
                <ExploreCategory />
                {visibleSections && visibleSections.includes('aboutUs') && <HomeAbout aboutUs={aboutUs} />}
                {visibleSections && visibleSections.includes('features') && <PlatForms features={features} />}
                {visibleSections && visibleSections.includes('featuredCourses') && <FeaturedCourses featuredCourses={featuredCourses} />}
                <ContactUs />
                <Footer />
            </div>
        </>
    )
}

export default Home
